// noinspection JSXUnresolvedComponent

import { Link } from 'react-router-dom';
import { joinClassNames } from '../../Helpers/Functions';
import React from 'react';

export const DesktopSidebarNavItem = ({ item, isOpen, t }) => (
  <Link
    to={item.path}
    className={joinClassNames(
      'group m-4 flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold',
      item.current ? '' : 'text-gray-700',
      !isOpen && 'my-2'
    )}
  >
    <div className={`group-hover:bg-pdwhite rounded-md ${item.current ? 'bg-pdwhite' : 'bg-[#1C333C]'}`}>
      <item.icon
        aria-hidden="true"
        className={joinClassNames(
          'shrink-0 p-2',
          item.current ? 'text-pddarkblue' : 'text-pdwhite group-hover:text-pddarkblue',
          isOpen ? 'size-12' : 'size-14'
        )}
      />
    </div>
    {isOpen && <span className={'text-pdwhite self-center lg:ml-2 lg:pt-1'}>{t(item.name)}</span>}
  </Link>
);
